const special_token_tr = {
  '：': ':',
  ' ': ''
};
const fieldTags = {
  'remark.name': {
    special_token: ['客戶姓名', 'Client Name'],
    separator: '\n'
  },
  'remark.profile': {
    special_token: ['客戶資料', 'Client Profile'],
    separator: '\n'
  },
  'remark.hobbies': {
    special_token: ['習慣/興趣', 'Habits / Interest'],
    separator: '\n'
  },
  'remark.family_status': {
    special_token: ['家庭狀況', 'Family Status'],
    separator: '\n'
  },
  'remark.financial_status': {
    special_token: ['財務狀況', 'Financial Situation'],
    separator: '\n'
  },
  'remark.liquid_asset': {
    special_token: ['可動用資金', 'Budget for Insurance Product'],
    separator: '\n'
  },
  'remark.insurance_product': {
    special_token: ['購買的保險產品', 'Purchased Insurance Product'],
    separator: '\n'
  },
  'remark.attitude': {
    special_token: ['對保險的態度', 'Attitude to Insurance'],
    separator: '\n'
  },
  'remark.budget': {
    special_token: ['保險產品的預算', 'Attitude to Insurance'],
    separator: '\n'
  },
  'remark.next_meeting': {
    ignore: true,
    special_token: ['下次會議的主題與目標', 'Next Meeting Subject and Goal'],
    separator: '\n'
  }
};
const preEdit = (/**@type {String} */ remark) => {
  let nx = remark;
  Object.entries(special_token_tr).forEach(val => {
    nx = nx.replaceAll(val[0], val[1]);
  });
  return nx;
};

const getRemarkDataGrid = remarks => {
  return remarks.reduce((acc, val) => {
    const next = { ...acc };
    val.forEach(element => {
      Object.entries(fieldTags).forEach(field => {
        // console.log('field:', field);
        if (field[1].ignore) return;
        const contentKey = field[0];
        const special_token = field[1].special_token;

        if (special_token.map(e => element.includes(e)).includes(true) && !element.endsWith(field[1].separator)) {
          if (next[contentKey]) {
            next[contentKey] = [...next[contentKey], element];
          } else {
            // console.log('if2 combineRemark element:', element);
            next[contentKey] = [element];
          }
        }
      });
    });
    return next;
  }, {});
};

const getCombineRemark = (/** @type {String} */ remark) => {
  if (!remark) return;
  if (!remark.includes('📅')) remark;
  const vRemark = preEdit(remark);
  const remarks = vRemark.split('📅');
  const datas = remarks.map(val => val.split('\n'));
  const dataGrid = getRemarkDataGrid(datas);
  const dataGridLength = Object.keys(dataGrid).length;

  let combinedRemark;
  if (dataGridLength) {
    combinedRemark = Object.values(dataGrid)
      .map((val, index) => val[0])
      .join('\n');
  } else {
    combinedRemark = remark;
  }
  return {
    remark: combinedRemark,
    grid: dataGridLength === 0 ? datas : dataGrid,
    length: dataGridLength === 0 ? datas.length : dataGridLength
  };
};

export { getCombineRemark, getRemarkDataGrid };
